import consts, { TypeCanvasElement } from "shared/consts";

export const ICON_SIZE = 20;
export const ICON_COLOR = "white";

export const displayNameForFilterables: Record<TypeCanvasElement, null | string> = {
  [consts.CANVAS_ELEMENTS.ICON]: "Shape",
  [consts.CANVAS_ELEMENTS.SHAPE]: "Shape",
  [consts.CANVAS_ELEMENTS.CONNECTOR]: "Connector",
  [consts.CANVAS_ELEMENTS.TEXT_BLOCK]: "Text",
  [consts.CANVAS_ELEMENTS.DRAWING]: "Drawing",
  [consts.CANVAS_ELEMENTS.STICKY_NOTE]: "Sticky note",
  [consts.CANVAS_ELEMENTS.FILE]: "Image",
  [consts.CANVAS_ELEMENTS.TASK_CARD]: "Task card",
  [consts.CANVAS_ELEMENTS.FRAME]: "Frame",
  [consts.CANVAS_ELEMENTS.COMMENT]: null,
  [consts.CANVAS_ELEMENTS.MINDMAP]: "Mindmap",
  [consts.CANVAS_ELEMENTS.MINDMAP_ORG_CHART]: "Smart org-chart",
  [consts.CANVAS_ELEMENTS.ORG_CHART]: "Org chart",
  [consts.CANVAS_ELEMENTS.ORG_CHART_NODE]: null,
  [consts.CANVAS_ELEMENTS.INTEGRATION]: "Monday item",
  [consts.CANVAS_ELEMENTS.CARD_STACK]: "Card stack",
  [consts.CANVAS_ELEMENTS.LIVE_INTEGRATION]: "Live card stack",
  [consts.CANVAS_ELEMENTS.TIMELINE]: "Timeline",
  [consts.CANVAS_ELEMENTS.TABLE]: "Table",
  [consts.CANVAS_ELEMENTS.GANTT]: "Gantt",
  [consts.CANVAS_ELEMENTS.TABLE_CELL]: null,
  [consts.CANVAS_ELEMENTS.NOUN_ICON]: "Icon",
  [consts.CANVAS_ELEMENTS.CHART]: "Chart",
  [consts.CANVAS_ELEMENTS.PDF]: "PDF",
  [consts.CANVAS_ELEMENTS.TASK]: "Task",
  [consts.CANVAS_ELEMENTS.MONDAY_TASK]: "monday Task",
};
